import { createContext, Dispatch, ReactNode, SetStateAction, useMemo, useState } from 'react';
import Customer from '../models/Customer';

type SearchContextType = {
  searchResult: Customer[];
  setSearchResult: Dispatch<SetStateAction<any>>;
  showNotification: boolean;
  setShowNotification: Dispatch<SetStateAction<any>>;
}

const SearchContext = createContext<SearchContextType>({
  searchResult: [],
  setSearchResult: () => undefined,
  showNotification: false,
  setShowNotification: () => undefined,
});

export function SearchContextProvider(props: { children: ReactNode }) {
  const [searchResult, setSearchResult] = useState([]);
  const [showNotification, setShowNotification] = useState(false);

  const providerValue = useMemo(() => ({
    searchResult,
    setSearchResult,
    showNotification,
    setShowNotification,
  }), [searchResult, showNotification]);

  return (
    <SearchContext.Provider value={providerValue}>{props.children}</SearchContext.Provider>
  );
}

export default SearchContext;
